import React, { useMemo } from 'react';
import TableComponentAptMetrix from './TableComponentAptMetrix';
import { FilterBar as FilterComponent } from './filters';
import FilterStatusBanner from './FilterStatusBanner';
import SaveConditionButton from './SaveConditionButton';
import { useFilterContext } from '../context/aptmetrix/FilterContext';
import { applyAllFilters } from '../util/aptMetrixFilters';

export default function ResultOfAptMetrixContainer({
  isFetchingAptMetrixInfo,
  aptMetrixInfoFetchError,
  aptMetrixInfo,
  columnOrderForAptMetrix,
  onSaleClick,
  onBookmarkClick,
  onSaveCondition,
  onRegionSelect,
}) {
  const {
    priceFilter, setPriceFilter,
    householdFilter, setHouseholdFilter,
    areaFilter, setAreaFilter,
    gapFilter, setGapFilter,
    moveInDateFilter, setMoveInDateFilter,
    subdistrictFilter, setSubdistrictFilter,
    subwayFilter, setSubwayFilter,
    gangnamTimeFilter, setGangnamTimeFilter,
    schoolFilter, setSchoolFilter,
  } = useFilterContext();

  const filters = {
    priceFilter, householdFilter, areaFilter, gapFilter,
    moveInDateFilter, subdistrictFilter, subwayFilter,
    gangnamTimeFilter, schoolFilter,
  };

  const filteredData = useMemo(
    () => applyAllFilters(aptMetrixInfo, filters),
    [aptMetrixInfo, priceFilter, householdFilter, areaFilter, gapFilter,
     moveInDateFilter, subdistrictFilter, subwayFilter, gangnamTimeFilter, schoolFilter]
  );

  return (
    <>
      <FilterComponent
        data={filteredData}
        onRegionSelect={onRegionSelect}
        onPriceFilterChange={setPriceFilter}
        onHouseholdFilterChange={setHouseholdFilter}
        onAreaFilterChange={setAreaFilter}
        onGapFilterChange={setGapFilter}
        onMoveInDateFilterChange={setMoveInDateFilter}
        onSubdistrictFilterChange={setSubdistrictFilter}
        onSubwayFilterChange={setSubwayFilter}
        onGangnamTimeFilterChange={(v) => setGangnamTimeFilter(v || { maxTime: null })}
        onSchoolFilterChange={setSchoolFilter}
      />

      <div className="flex justify-between items-center">
        <FilterStatusBanner filteredData={filteredData} aptMetrixInfo={aptMetrixInfo} />
        {onSaveCondition && <SaveConditionButton onSave={onSaveCondition} />}
      </div>

      <TableComponentAptMetrix
        columnOrder={columnOrderForAptMetrix}
        data={filteredData}
        onSaleClick={onSaleClick}
        onBookmarkClick={onBookmarkClick}
        isLoading={isFetchingAptMetrixInfo}
        error={aptMetrixInfoFetchError}
      />
    </>
  );
}
